<template functional>
  <div class="viewbar">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class NViewbar extends Vue {}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.viewbar {
  display: flex;
  align-items: center;
  overflow-y: visible;
  overflow-x: auto;
  padding: $notch-space-4x 0;

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  &:hover {
    &::-webkit-scrollbar-thumb {
      background-color: $notch-color-neutral-sand-300;
    }
  }
}
</style>
